// Public origin for share links: the technical *.emergent.host domain is mapped to the custom domain.
export const shareOrigin = () =>
  window.location.hostname.endsWith("emergent.host") && process.env.REACT_APP_PUBLIC_ORIGIN
    ? process.env.REACT_APP_PUBLIC_ORIGIN
    : window.location.origin;

export const shareUrlFor = (id) => `${shareOrigin()}/api/share/${id}`;

// Markdown -> readable plain text for emails / messages.
export const markdownToPlain = (md = "") =>
  md
    .replace(/\r/g, "")
    .replace(/^#{1,6}\s*(.+)$/gm, (_, h) => `\n${h.replace(/\*\*/g, "").trim().toUpperCase()}`)
    .replace(/\*\*(.+?)\*\*/g, "$1")
    .replace(/__(.+?)__/g, "$1")
    .replace(/(^|[^*])\*(?!\s)(.+?)\*/g, "$1$2")
    .replace(/^\s*[-*+]\s+/gm, "• ")
    .replace(/^>\s?/gm, "")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/\[(.+?)\]\((.+?)\)/g, "$1 ($2)")
    .replace(/^\s*\|?-{3,}.*$/gm, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
